export { APP_CONFIG, Language } from './config';
export { CoreModule } from './core.module';
